import { type UseQueryResult, useQuery } from 'react-query';
import { LandingPageService } from '@wealthlane/api-services/wealthlane-identity-service';

const useGetLandingPageOption = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const landingPageOptions = useQuery(
    ['getLandingPageOption'],
    async () => {
      return await handleRequest(
        LandingPageService.getApiIdentityApiAppLandingPageLandingPageOptions()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.value ?? '',
          };
        });
      },
    }
  );

  return landingPageOptions;
};

export default useGetLandingPageOption;
